import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import _ from 'lodash';
import { FormProvider, useForm } from 'react-hook-form';
import {
  IDependentValue,
  IReviewerRecommendation
} from '@publishing-engine/domain/models';
import { generateValidationSchema } from 'src/utils/validation';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import { IReviewerValue } from './index';
import ReviewerRecommendation, {
  IReviewersFormField
} from 'src/pages/Organization/public/Journal/SubmissionUpload/components/ReviewerRecommendation';
import { useSubmissionData } from '../../../../contexts/SubmissionDataProvider';

export type IDependentReviewers = {
  [x: string]: {
    [y: string]: IReviewerValue;
  };
};

interface Props {
  onSubmit: (value: IDependentValue<IReviewerRecommendation[]>) => void;
  onClose: () => void;
  isOpen: boolean;
  formField: IReviewersFormField;
  value?: IDependentValue<IReviewerRecommendation[]>;
}

export const ReviewersUpdateModal: React.FC<Props> = props => {
  const { onSubmit, onClose, formField, value, isOpen } = props;
  const { submissionContextId, submissionId, submissionContext } =
    useSubmissionData();

  const defaultValues = _.set(
    {} as IDependentReviewers,
    formField.caseDataFields.main,
    { ...value, value: [] }
  );

  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  const handleSubmit = (data: IDependentReviewers) => {
    onSubmit(
      _.get(data, formField.caseDataFields.main) as unknown as IReviewerValue
    );
    onClose();
  };

  return (
    <FormProvider {...methods}>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        width="900px"
        closeButtonProps={{
          hidden: true
        }}
      >
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
            flex={1}
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <ReviewerRecommendation
                draftId={submissionId}
                ctxId={submissionContextId}
                lexiconProjectId={
                  submissionContext?.config.lexiconProjectId ?? ''
                }
                config={formField}
                type="submission"
                skipAffiliationCheck={formField.name ==="OpposedReviewers" ? true : false}
              />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
              >
                Exit Without Saving
              </Button>
              <Button variant="primary" type="submit" borderRadius="small">
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </Modal>
    </FormProvider>
  );
};
